<div class="basicrow tabtopb f-black roboto-r f-reg">
    <div class="basicrow">
        <div class="row">
            <div class="actual-plan-box">
                <div class="userinfo full nomtops">
                    <div class="basicrow m-bott">
                        <div class="basicrow f-bmed roboto-b m-bott">
                            PLAN ACTUAL:
                        </div>
                        <div class="redstat">
                            <div class="basicrow" style="line-height: 1.5; text-align: justify;">
                                {{this.currentPlan}}<br>
                            </div>
                        </div>
                    </div>
                    <div class="basicrow text-center m-top-ii">
                        <div class="basicrow">
                            <span class="roboto-b">
                              PRECIO                          
                            </span><br>
                            <span class="f-gray f-semi roboto-m">
                              {{this.actualPrice | currency}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="selected-plan-box h-mtop">
                <div class="userinfo trnsinfo full nomtops plan-selected">
                    <div class="basicrow m-bott">
                        <div class="basicrow f-bmed roboto-b m-bott">
                            PLAN SELECCIONADO:
                        </div>
                        <div class="redstat">
                            <div class="basicrow" style="line-height: 1.5; text-align: justify;">
                                {{this.planToChange}} :
                                <span *ngFor="let description of this.descriptions; let n = index">
                                  {{description.description}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="basicrow text-center m-top-ii">
                        <div class="basicrow borde-precio">
                            <span class="roboto-b">
                              PRECIO
                            </span><br>
                            <span class="f-red f-semi roboto-m">
                              {{this.pricePlan|currency}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="basicrow m-top-i m-bott">
        <div class="logline full"></div>
    </div>
    <div class="basicrow text-center m-top-i">
        <div class="basicrow roboto-b">
            Recuerde que su pr&oacute;xima factura puede reflejar cargos fraccionales relacionados a su nueva tarifa.
        </div>
        <div *ngIf="this.textoMovil==false" class="basicrow m-top">
            Para tu conveniencia. Claro incluirá el cargo en tu factura de servicios mensuales. Favor escoja entre las opciones de cuando desea que se haga efectivo.
        </div>
        <div *ngIf="this.textoMovil==true" class="basicrow m-top">
            Términos del contrato
        </div>
    </div>
    <div class="basicrow m-top" *ngIf="this.textoMovil==false">
        <div class="row">
            <div class="date-1">
                <div class="optchoice hauto roboto-r text-left caja1" id="content-activacion1" (click)="this.changeCheck('activacion',1)">
                    <div class="checkdef">
                        <input type="radio" name="radioActivacion" id="radio-activacion1" class="css-radio"><label for="radioG1" class="css-label3 radGroup1"></label>
                    </div>
                    <div class="basicrow f-med roboto-b opc1">&#191;Desea activar su nuevo plan de inmediato&#63;</div>
                    <div class="basicrow m-top-u-i roboto-b opc1">
                        {{this.currentDate()}}
                    </div>
                </div>
            </div>
            <div class="date-2">
                <div class="optchoice hauto roboto-r text-left caja2" id="content-activacion2" (click)="this.changeCheck('activacion',2)">
                    <div class="checkdef">
                        <input type="radio" name="radioActivacion" id="radio-activacion2" class="css-radio"><label for="radioG1" class="css-label3 radGroup1"></label>
                    </div>
                    <div class="basicrow f-med roboto-b opc2">&#191;Desea activar su nuevo plan en su pr&oacute;ximo ciclo de factura&#63;</div>
                    <div class="basicrow m-top-u-i roboto-r opc2">
                        Escoja esta opci&oacute;n si desea que no apliquen prorrateos en su pr&oacute;xima factura.
                    </div>
                    <div class="basicrow m-top-u-i roboto-b opc2">
                        {{this.nextDate}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="basicrow m-top" *ngIf="this.textoMovil==true">
        <div class="row">
            <div class="months-12" *ngIf="this.commitmentOriginalMonths==0 || this.commitmentOriginalMonths==12">
                <div class="optchoice hauto roboto-r text-left caja1" id="content-contrato1" (click)="this.changeCheck('contrato',1)">
                    <div class="checkdef">
                        <input type="radio" name="radioContrato" id="radio-contrato1" class="css-radio"><label for="radioG1" class="css-label3 radGroup1"></label>
                    </div>
                    <div class="basicrow opttext">
                        <div class="basicrow f-med roboto-b">12 meses</div>
                        <div class="basicrow m-top-u-i roboto-b">
                        </div>
                    </div>
                </div>
            </div>
            <div class="months-24">
                <div class="optchoice hauto roboto-r text-left caja2" id="content-contrato2" (click)="this.changeCheck('contrato',2)">
                    <div class="checkdef">
                        <input type="radio" name="radioContrato" id="radio-contrato2" class="css-radio"><label for="radioG2" class="css-label3 radGroup1"></label>
                    </div>
                    <div class="basicrow opttext f-med roboto-b">24 meses</div>
                </div>
            </div>
        </div>
    </div>
    <div class="basicrow text-center m-top-i caja-terminos" *ngIf="this.textoMovil==false">
        <input id="activatedTerms" (click)="this.activateTerms()" type="checkbox"> <a (click)="this.showterms()" class="linkdefs" style="cursor: pointer;"> Acepto T&eacute;rminos y Condiciones <i class="fa fa-angle-right" aria-hidden="true"></i></a>
    </div>
    <div class="basicrow text-center m-top-i caja-terminos" *ngIf="this.textoMovil==true">
        <input id="activatedTerms" (click)="this.activateTerms()" type="checkbox"> <a (click)="this.showtermsFixed()" class="linkdefs" style="cursor: pointer;"> Acepto T&eacute;rminos y Condiciones <i class="fa fa-angle-right" aria-hidden="true"></i></a>
    </div>
    <div class="basicrow m-top-i">
        <div class="logline full"></div>
    </div>
    <div class="basicrow text-center m-top">
        <a class="btns def-i red pull-right vcenter derecha" (click)="this.applyChange()">
            <span class="tabcell">
              Cambiar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
        <a (click)="this.backPage()" class="btns def-i gray pull-left vcenter izquierda">
            <span class="tabcell">
              <i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Regresar
            </span>
        </a>
    </div>
</div>